var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var dividerSx = {
    color: "#fff",
    opacity: "0.3",
    width: "2px",
    height: "55%",
};
export var selectionBannerSx = {
    ".csg-tui-tooltip": {
        top: "7px !important",
    },
};
export var textSx = {
    color: "#fff",
    fontFamily: "Helvetica",
    letterSpacing: "0.55px",
};
export var buttonTextSx = __assign(__assign({}, textSx), { fontSize: "14px", backgroundColor: "transparent", border: "none", margin: "0px 10px", "&:active, &:focus": {
        border: "none",
        boxShadow: "none",
    } });
export var buttonTextWithHoverSx = __assign(__assign({}, buttonTextSx), { "&:hover": {
        opacity: "unset !important",
        backgroundColor: "rgba(255, 255, 255, 0.3);",
    } });
export var buttonTextDisabledSx = __assign(__assign({}, buttonTextSx), { cursor: "not-allowed", opacity: "0.6", "&:hover": {
        opacity: "0.6 !important",
    }, "*": {
        cursor: "not-allowed",
    } });
export var checkAllSx = {
    cursor: "pointer",
    // marginRight: "25px",
    opacity: "0.8",
    "&:hover": {
        opacity: "1 !important",
    },
};
export var checkAllActiveSx = __assign(__assign({}, checkAllSx), { opacity: 1 });
export var checkAllDisabledSx = {
    // marginRight: "25px",
    cursor: "not-allowed",
    "&:hover": {
        opacity: "1 !important",
    },
};
//# sourceMappingURL=styles.js.map